'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { useCallback, useMemo } from 'react'
import { Holding, useHoldings } from '@hooks/useHoldings'
import { getQueryString } from '@utils/index'
import { Routes } from 'src/app/holdings/[route]/page'
import Main from './components/Main'

interface HoldingsPageProps {
  routes: Routes
  selectedRoute: string
}

export default function HoldingsPage({
  routes,
  selectedRoute,
}: HoldingsPageProps) {
  const params = useSearchParams()
  const router = useRouter()
  const navRoutes = useMemo(
    () => routes.map((route) => ({ name: route, isNav: true })),
    [],
  )

  const mainPageFunctions = {
    selectHoldingHandler: useCallback(
      (holding: Holding) => {
        const query = getQueryString(
          params,
          'dewi',
          holding.publicKey.toBase58(),
        )
        router.push(`/holdings/${selectedRoute}${query}`)
      },
      [params],
    ),
    selectRouteHandler: useCallback((value: string) => {
      router.push(`/holdings/${value}`)
    }, []),
  }

  const holdingsHook = useHoldings(selectedRoute as Routes[number])

  return (
    <Main
      selectedRoute={selectedRoute}
      routes={navRoutes}
      params={params}
      {...mainPageFunctions}
      {...holdingsHook}
    />
  )
}
